const html = require('choo/html');
const assets = require('../../common/assets');
// Do not `require('*.svg')` here: this module loads in Node (SSR via app/routes → home),
// where webpack loaders do not run — Node would try to execute XML as JS and throw.

module.exports = function intro(state, _emit) {
  return html`
    <send-intro
      class="flex flex-col items-start justify-start bg-white p-6 md:p-10 w-full min-h-[12rem] dark:bg-grey-90 rounded-2xl shadow-sm overflow-x-hidden"
      style="height: 60vh; min-height: 400px; max-height: 600px;"
    >
      <div class="flex flex-col items-start text-left w-full">
        <!-- Header with Logo and Title -->
        <div class="flex items-center mb-6 animate-fade-in flex-shrink-0">
          <div class="p-2.5 bg-blue-50/10 dark:bg-blue-40/10 rounded-xl mr-4 flex-shrink-0">
            <img class="w-8 h-8 md:w-10 md:h-10" src="${assets.get('intro.svg')}" alt="Logo" />
          </div>
          <h1 class="text-xl md:text-2xl font-bold text-grey-90 dark:text-grey-10 leading-tight tracking-tight">
            ${state.translate('introTitle')}
          </h1>
        </div>
        
        <div class="w-12 h-1 bg-blue-60 rounded-full mb-6 flex-shrink-0"></div>

        <!-- Description Area -->
        <div class="flex-grow overflow-y-auto scrollbar-thin pr-2 mb-4 custom-scroll-container">
          <div class="space-y-4">
            <p class="text-base md:text-lg text-grey-70 dark:text-grey-30 leading-relaxed font-medium">
              ${state.translate('introDescription')}
            </p>
            
            <div class="relative">
              <p class="text-sm text-grey-50 dark:text-grey-40 leading-relaxed">
                ${state.translate('introSubDescription')}
              </p>
            </div>
          </div>

          <!-- Feature Grid -->
          <div class="grid grid-cols-1 gap-4 border-t border-grey-10 dark:border-grey-80 pt-6 mt-6">
            <div class="flex items-start group">
              <div class="h-8 w-8 bg-green-50/10 dark:bg-green-40/10 rounded-lg flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                <svg class="h-4 w-4 text-green-60 dark:text-green-40"><use xlink:href="${assets.get('lock.svg')}#icon"/></svg>
              </div>
              <div>
                <h3 class="text-xs font-bold text-grey-80 dark:text-grey-20 uppercase tracking-wider leading-none mb-1">${state.translate('uploadSecureTransfer')}</h3>
                <p class="text-[10px] text-grey-50 dark:text-grey-50 uppercase font-medium">${state.translate('aesEncryption')}</p>
              </div>
            </div>
            
            <div class="flex items-start group">
              <div class="h-8 w-8 bg-purple-50/10 dark:bg-purple-40/10 rounded-lg flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                <svg class="h-4 w-4 text-purple-60 dark:text-purple-40"><use xlink:href="${assets.get('expiry.svg')}#icon"/></svg>
              </div>
              <div>
                <h3 class="text-xs font-bold text-grey-80 dark:text-grey-20 uppercase tracking-wider leading-none mb-1">${state.translate('linkExpiryLabel')}</h3>
                <p class="text-[10px] text-grey-50 dark:text-grey-50 uppercase font-medium">${state.translate('expiryDescription')}</p>
              </div>
            </div>

            <div class="flex items-start group">
              <div class="h-8 w-8 bg-blue-50/10 dark:bg-blue-40/10 rounded-lg flex items-center justify-center mr-3 flex-shrink-0 mt-0.5">
                <svg class="h-4 w-4 text-blue-60 dark:text-blue-40"><use xlink:href="${assets.get('completed.svg')}#icon"/></svg>
              </div>
              <div>
                <h3 class="text-xs font-bold text-grey-80 dark:text-grey-20 uppercase tracking-wider leading-none mb-1">${state.translate('uploadComplete')}</h3>
                <p class="text-[10px] text-grey-50 dark:text-grey-50 uppercase font-medium">${state.translate('instantShare')}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Info -->
        <div class="flex-shrink-0 pt-4 border-t border-grey-10 dark:border-grey-80 w-full mt-auto">
           <div class="flex items-center justify-center space-x-2 text-[11px] text-grey-40 dark:text-grey-60 font-medium">
             <span>${state.translate('footerOpenSource')}</span>
             <span class="h-1 w-1 bg-grey-30 rounded-full"></span>
             <span>${state.translate('footerPrivacy')}</span>
             <span class="h-1 w-1 bg-grey-30 rounded-full"></span>
             <span>${state.translate('footerEncryption')}</span>
           </div>
        </div>
      </div>
    </send-intro>
  `;
};
